// Single source for the publisher/company name shown in the in-app copyright lines
// (web footer, account screen, welcome screen). Change it here and every in-app
// copyright updates. The marketing site and legal pages keep their own copies —
// they're a separate app (apps/marketing) with their own build.
export const COMPANY_NAME = "LightSource";
